export const checkExtension = (extension: string) => {
  if (extension === 'JPG') {
    return 'jpg'
  } else if (extension === 'xls') {
    return 'xlsx'
  } else {
    return extension
  }
}
